import { Provider, context as context_ } from './_provider'
export const context = context_
export default Provider
